var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trophy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.8 10l1.4-8.9-18.2-1.1-18.2 1.1 1.4 8.9h-7.2v1c0 12.6 10.1 22.8 22.6 23-1.2 3.3-5.1 12-12.6 12v2h28v-2c-7.5 0-11.4-8.7-12.6-12 12.5-0.2 22.6-10.4 22.6-23v-1h-7.2zm-38.8 2h5.6l0.4 2.7c1.3 8 4.4 13 7.8 16-8-2.9-13.4-10.3-13.8-18.7zm29.6 34h-15.2c3.9-2.6 6.3-7.2 7.6-10.1 1.2 2.9 3.6 7.5 7.6 10.1zm-7.6-14c-7.7 0-12.5-8.8-14-17.6l-1.8-11.5 15.8-0.9 15.8 0.9-1.8 11.5c-1.3 8.5-6.3 17.6-14 17.6zm8.2-1.3c4.2-3.7 6.9-10 7.8-16l0.4-2.7h5.6c-0.4 8.4-5.9 15.8-13.8 18.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.ffca4d6c83a57fda7dc4f0fcae952800.svg";
export { ForwardRef as ReactComponent };